// import { useDispatch } from "react-redux";
// import { getSideBarfilesActions } from "../../Redux/Slice";

// // ✅ Shared route map
// const routeMap = {
//   "overview": "/",
//   "onboard overview": "/onboardDashboard",
//   "advance dashboard": "/advance_dashboard",
//   "advance attendance": "/advance_attendance",
//   "report overview": "/validation",
//   "aadhaar card report": "/aadharvalidate",
//   "pan card report": "/panvalidate",
//   "whatsapp report": "/whatsappvalidate",
//   "bank penny drop report": "/bankvalidate",
//   "master dashboard": "/master_dash",
//   "client": "/client",
//   "designation": "/designation",
//   "employees": "/employeeaction",
//   "user": "/user",
//   "approve request": "/approverequestemp",
//   "onboarding": "/fieldagent",
//   "my onboarding list": "/myonboarding",
//   "attendance report": "/report",
//   "leave type": "/leavetype",
//   "leave request": "/leavepermission",
//   "permission request": "/Permission",
//   "attendance regularization": "/attendancerequest",
//   "overtime regularization": "/overtimerequest",
//   "criteria": "/performance",
//   "assessments request": "/manpower",
//   "no due form": "/exit",
//   "resign": "/resign",
//   "reimbursement": "/reimbursement",
//   "employee block  request": "/blocklist",
//   "site transfer": "/sitetransfer",
//   "active and deactive": "/activeEmployee",
//   "payslip": "/payslip",
//   "grievance type": "/grievance",
//   "grievance list": "/grievancelist",
//   "ticket category": "/ticketcategory",
//   "tickets": "/tickets",
//   "my tickets": "/mytickets",
//   // "dashboard": "/ticketdashboard",
//   "unregistered": "/unregisterticket",
//   "attendance location": "/attendancelocation",
//   "state": "/state",
//   "region": "/region",
//   "zone": "/zone",
// };

// // ✅ Shared helper logic (NO hooks here)
// const handleNavigation = (sidebarMenu, dispatchFn) => {
//   if (!Array.isArray(sidebarMenu) || sidebarMenu.length === 0) return;

//   const matchedKey = Object.keys(routeMap).find((key) =>
//     sidebarMenu.includes(key)
//   );
//   const path = matchedKey ? routeMap[matchedKey] : "/";
//   const matchedName = matchedKey || "Default Route";

//   console.log(`✅ Navigating to: ${path} (Menu: ${matchedName})`);
//   dispatchFn(getSideBarfilesActions(matchedName));

//   // Update browser path manually
//   window.history.pushState({}, "", path);
//   window.dispatchEvent(new PopStateEvent("popstate"));
// };

// // ✅ React Hook version (for React Components only)
// export const useNavigateUserByAccess = () => {
//   const dispatch = useDispatch();

//   // ⚠️ make sure useDispatch is ONLY called here
//   const navigateUserByAccess = (sidebarMenu) => {
//     handleNavigation(sidebarMenu, dispatch);
//   };

//   return { navigateUserByAccess };
// };

// // ✅ Plain JS version (for Saga or non-React code)
// export const navigateUserByAccessUtil = (sidebarMenu, dispatchFn) => {
//   handleNavigation(sidebarMenu, dispatchFn);
// };

import { useDispatch } from "react-redux";
import { getSideBarfilesActions } from "../../Redux/Slice";

// ✅ Shared route map
const routeMap = {
  "overview": "/",
  "onboard overview": "/onboardDashboard",
  "advance dashboard": "/advance_dashboard",
  "advance attendance": "/advance_attendance",
  "attendance dashboard": "/attendance_dashboard",
  "report overview": "/validation",
  "aadhaar card report": "/aadharvalidate",
  "pan card report": "/panvalidate",
  "whatsapp report": "/whatsappvalidate",
  "bank penny drop report": "/bankvalidate",
  "master dashboard": "/master_dash",
  "client": "/client",
  "designation": "/designation",
  "employees": "/employeeaction",
  "user": "/user",
  "approve request": "/approverequestemp",
  "onboarding": "/fieldagent",
  "my onboarding list": "/myonboarding",
  "attendance report": "/report",
  "leave type": "/leavetype",
  "leave request": "/leavepermission",
  "permission request": "/Permission",
  "attendance regularization": "/attendancerequest",
  "overtime regularization": "/overtimerequest",
  "criteria": "/performance",
  "assessments request": "/manpower",
  "no due form": "/exit",
  "resign": "/resign",
  "reimbursement": "/reimbursement",
  "employee block  request": "/blocklist",
  "site transfer": "/sitetransfer",
  "active and deactive": "/activeEmployee",
  "payslip": "/payslip",
  "grievance type": "/grievance",
  "grievance list": "/grievancelist",
  "ticket category": "/ticketcategory",
  "tickets": "/tickets",
  "my tickets": "/mytickets",
  "unregistered": "/unregisterticket",
  "attendance location": "/attendancelocation",
  "state": "/state",
  "region": "/region",
  "zone": "/zone",
};

// ✅ Shared helper logic (NO hooks here)
// const handleNavigation = (sidebarMenu, dispatchFn) => {
//   if (!Array.isArray(sidebarMenu) || sidebarMenu.length === 0) return;

//   // 🔍 Match the key from routeMap
//   let matchedKey = Object.keys(routeMap).find((key) =>
//     sidebarMenu.includes(key)
//   );

//   // ⚙️ If any item includes "dashboard", treat it as "overview"
//   if (
//     !matchedKey &&
//     sidebarMenu.some((item) => item.toLowerCase().includes("dashboard"))
//   ) {
//     matchedKey = "overview";
//   }

//   const path = matchedKey ? routeMap[matchedKey] : "/";
//   const matchedName = matchedKey || "Default Route";
// const formattedName = matchedName
//   .trim() // remove extra spaces
//   .split(/\s+/) // split on one or more spaces
//   .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//   .join(" ");
//   console.log(`✅ Navigating to: ${path} (Menu: ${matchedName} , ${formattedName})`);

//   // Dispatch Redux action
//   dispatchFn(getSideBarfilesActions(formattedName));

//   // Update browser path manually
//   window.history.pushState({}, "", path);
//   window.dispatchEvent(new PopStateEvent("popstate"));
// };

// ✅ Shared helper logic (NO hooks here)
const handleNavigation = (sidebarMenu, dispatchFn, isReportingPerson = false) => {
  if (!Array.isArray(sidebarMenu) || sidebarMenu.length === 0) return;

  // Normalize all menu items (trim + lowercase)
  const normalizedMenu = sidebarMenu.map((item) => item.toLowerCase().trim());

  // Reporting persons with dashboard access land on the Attendance Dashboard
  if (isReportingPerson && normalizedMenu.includes("dashboard")) {
    dispatchFn(getSideBarfilesActions("Attendance Dashboard"));
    window.history.pushState({}, "", routeMap["attendance dashboard"]);
    window.dispatchEvent(new PopStateEvent("popstate"));
    return;
  }

  // 🔍 Force "overview" if any menu item includes "dashboard"
  if (normalizedMenu.some((item) => item.includes("dashboard"))) {
    const matchedKey = "overview";
    const path = routeMap[matchedKey] || "/";
    const formattedName = "Overview";

    console.log(`✅ Navigating to: ${path} (Menu: ${matchedKey}, ${formattedName})`);

    // Dispatch Redux action
    dispatchFn(getSideBarfilesActions(formattedName));

    // Update browser path manually
    window.history.pushState({}, "", path);
    window.dispatchEvent(new PopStateEvent("popstate"));
    return; // ✅ Stop here, since we handled it
  }

  // 🔍 Otherwise, find the first matched key in routeMap
  let matchedKey = Object.keys(routeMap).find((key) =>
    normalizedMenu.includes(key.toLowerCase())
  );

  // Default to root if no match found
  const path = matchedKey ? routeMap[matchedKey] : "/";
  const matchedName = matchedKey || "Default Route";

  const formattedName = matchedName
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  console.log(`✅ Navigating to: ${path} (Menu: ${matchedName}, ${formattedName})`);

  // Dispatch Redux action
  dispatchFn(getSideBarfilesActions(formattedName));

  // Update browser path manually
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
};
// const handleNavigation = (sidebarMenu, dispatchFn) => {
//   if (!Array.isArray(sidebarMenu) || sidebarMenu.length === 0) return;

//   // Normalize all menu items (trim + lowercase)
//   const normalizedMenu = sidebarMenu.map((item) => item.toLowerCase().trim());

//   // 🧩 Special case for "kyc verification"
//   if (normalizedMenu.some((item) => item.includes("kyc verification"))) {
//     const matchedKey = "approve request"; // 👈 use the new label
//     const path = routeMap[matchedKey] || "/";
//     const formattedName = "Approve Request";

//     console.log(`✅ Navigating to: ${path} (Menu: ${matchedKey}, ${formattedName})`);

//     // Dispatch Redux action
//     dispatchFn(getSideBarfilesActions(formattedName));

//     // Update browser path manually
//     window.history.pushState({}, "", path);
//     window.dispatchEvent(new PopStateEvent("popstate"));
//     return; // ✅ Stop here, since we handled it
//   }

//   // 🔍 Force "overview" if any menu item includes "dashboard"
//   if (normalizedMenu.some((item) => item.includes("dashboard"))) {
//     const matchedKey = "overview";
//     const path = routeMap[matchedKey] || "/";
//     const formattedName = "Overview";

//     console.log(`✅ Navigating to: ${path} (Menu: ${matchedKey}, ${formattedName})`);

//     dispatchFn(getSideBarfilesActions(formattedName));

//     window.history.pushState({}, "", path);
//     window.dispatchEvent(new PopStateEvent("popstate"));
//     return;
//   }

//   // 🔍 Otherwise, find the first matched key in routeMap
//   let matchedKey = Object.keys(routeMap).find((key) =>
//     normalizedMenu.includes(key.toLowerCase())
//   );

//   // Default to root if no match found
//   const path = matchedKey ? routeMap[matchedKey] : "/";
//   const matchedName = matchedKey || "Default Route";

//   const formattedName = matchedName
//     .trim()
//     .split(/\s+/)
//     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(" ");

//   console.log(`✅ Navigating to: ${path} (Menu: ${matchedName}, ${formattedName})`);

//   dispatchFn(getSideBarfilesActions(formattedName));

//   window.history.pushState({}, "", path);
//   window.dispatchEvent(new PopStateEvent("popstate"));
// };

// ✅ React Hook version (for React Components only)
export const useNavigateUserByAccess = () => {
  const dispatch = useDispatch();

  const navigateUserByAccess = (sidebarMenu) => {
    handleNavigation(sidebarMenu, dispatch);
  };

  return { navigateUserByAccess };
};

// ✅ Plain JS version (for Saga or non-React code)
export const navigateUserByAccessUtil = (sidebarMenu, dispatchFn, isReportingPerson) => {
  handleNavigation(sidebarMenu, dispatchFn, isReportingPerson);
};

